<nz-page-header [nzBackIcon]="null" class="page-header dashboard-monitoring-page-header">
    <nz-page-header-title>
        <div class="dashboard-monitoring-header">
            <h3 class="dashboard-monitoring-title">
                {{ 'dashboard.monitoringTodoTitle' | translate }}
            </h3>
            <span class="dashboard-monitoring-title-info">{{ 'dashboard.clickableRows' | translate }}</span>
        </div>
    </nz-page-header-title>
    <nz-page-header-extra>
        <div class="dashboard-monitoring-extra" nz-flex nzJustify="flex-end" nzGap="middle" nzAlign="center"
            nzWrap="wrap">
            <div class="total-elements" nz-flex nzJustify="center" nzAlign="center" nzGap="small">
                <span><b>{{ 'dashboard.totalElements' | translate }}:</b></span>
                <nz-tag nzColor="processing">
                    <span><b>{{ total }}</b></span>
                </nz-tag>
            </div>
            <div class="reset-filters-action" nz-flex nzJustify="center" nzAlign="center">
                <button nz-button (click)="resetFilters()">
                    <span nz-icon nzType="reload" nzTheme="outline"></span>
                    <span>{{ 'common.reset_filters' | translate }}</span>
                </button>
            </div>
        </div>
    </nz-page-header-extra>
</nz-page-header>
<div class="dashboard-monitoring-table-wrapper">
    <nz-table #listData [nzBordered]="true" [nzData]="listOfMonitoringSheets" [nzSize]="'middle'"
        [nzLoading]="isLoadingData" [nzPageSize]="pageSize" [nzTotal]="total" [nzFrontPagination]="false"
        [nzPageIndex]="pageIndex" nzTableLayout="auto" nzShowSizeChanger (nzQueryParams)="onQueryParamsChange($event)"
        class="dashboard-monitoring-table">
        <thead>
            <tr class="sticky-header">
                @for (column of listOfColumns; track column.value; let i = $index) {
                <th [nzSortOrder]="column.sortOrder" [nzSortFn]="column.sortFn"
                    [nzSortDirections]="column.sortDirections" [nzFilters]="column.listOfFilter"
                    [nzFilterFn]="column.filterFn" [nzFilterMultiple]="column.filterMultiple"
                    [nzShowSort]="column.sortFn ? true : false" [nzShowFilter]="filterVisibility[column.value]"
                    [nzColumnKey]="column.value" [class.col-main]="i === 0" [class.col-fit]="i > 0">
                    <app-header-columns [column]="column" [treeData]="treeData"
                        (filterSearchChange)="onSearchFilterChange($event)"
                        (filterDateChange)="onFilterDateChange($event)"
                        (treeFilterNodes)="onTreeSelectionChange($event)"></app-header-columns>
                </th>
                }
            </tr>
        </thead>
        <tbody>
            @for (monitoringSheet of listData.data; track monitoringSheet; let i = $index) {
            <tr class="clickable-row" [tabindex]="i" (click)="redirectToMonitoringSheet($event, monitoringSheet.guid)"
                nz-tooltip [nzTooltipTitle]="'dashboard.completeTooltip' | translate"
                [nzTooltipColor]="derichebourgColorBlue">
                <td>
                    <div class="title-spj-container">
                        <span class="catalogsheet-title">{{ monitoringSheet.title }}</span>
                        <span class="spj-text">{{ monitoringSheet.spj }} - ({{ monitoringSheet.labelSector }})</span>
                    </div>
                </td>
                <td>{{ monitoringSheet.periodicity | frequencyTranslationKey | translate }}</td>
                <td>{{ monitoringSheet.endDate | utcDateFormat }}</td>
                <!-- <td>
                <a [routerLink]="['/monitoring-sheet/to-complete', monitoringSheet.guid]" target="_blank" nz-button
                    nzType="primary" nz-tooltip nzTooltipTitle="Remplir la FSO"
                    [nzTooltipColor]="derichebourgColorBlue">
                    <span nz-icon nzType="form" nzTheme="outline" class="icon-lg"></span>
                </a>
            </td> -->
            </tr>
            }
        </tbody>
    </nz-table>
</div>
<!-- </div> -->

<!-- <ng-template #drawerClose>
    <button nz-button nzType="default" (click)="closeDrawer()">
        <span nz-icon nzType="close" nzTheme="outline"></span>
        Fermer</button>
</ng-template> -->